// extracted by mini-css-extract-plugin
export default {"address":"index-module__address--91R8I"};